import React, { useRef, useState, useEffect } from "react";
import { get } from "../../../../../lib/api";
import PlayWithCircle from "../../../../../components/Images/PlayWithCircle";
import { Box } from "../../../../../designSystem";
import CircularProgressBar from "./circularProgressBar";
import { getSubText } from "./musicUtils";
import { GenreAgeText, ListDiv, PlayPauseBtn, SelectedGenreAgeText, TransformationTxt, VoiceItem, VoiceNameText } from "./styles";
import Loader from "../../../../../components/Loader";

const VoiceList = ({ musicSelected, onChangeSelection, genre }) => {
    const [currentTrackIndex, setCurrentTrackIndex] = useState(null);
    const [voiceList,updateVoiceList] = useState([])
    const audioRefs = useRef([]);
    const [angle, setAngle] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        const api = genre ? `/content_api/ugc/audio/voice_library/?vendor=eleven_labs&genre=${genre}&is_novel=1` : '/content_api/ugc/audio/voice_library/?vendor=eleven_labs&is_novel=1'
        setIsLoading(true)
        get(api).then((res) => {
            updateVoiceList(res)
            audioRefs.current = audioRefs.current.slice(0, res?.length);
            setIsLoading(false)
        }).catch((err) => setIsLoading(false))
      }, []);

    const handlePlayPause = (index) => {
        if (currentTrackIndex !== null && currentTrackIndex !== index) {
            const currentAudio = audioRefs.current[currentTrackIndex];
            if (currentAudio && !currentAudio.paused) {
              currentAudio.pause();
              currentAudio.currentTime = 0;
            }
        }
        const audio = audioRefs.current[index];
        if (audio.paused) {
            audio.play();
        } else {
            audio.pause();
        }
      
        setCurrentTrackIndex(index);
    }

    const handleAudioTimeUpdate = (event) => {
        if(event.target.currentTime === event.target.duration)
        {
            event.target.currentTime = 0;
            event.target.pause();
        }else{
            setAngle((event.target.currentTime / event.target.duration) * 360)
        }
    }

    return(
        <ListDiv>
            {isLoading ? <Loader /> : 
                <ul>
                    {voiceList?.map((voice,index) => { 
                        const isSelected = musicSelected?.value === voice?.value
                        return(
                        <li key={voice.value}>
                            <VoiceItem 
                                key={voice.value} 
                                onClick={() => onChangeSelection(voice)}
                                selected={isSelected}
                            >
                                <Box>
                                    <img 
                                        src={isSelected ? "https://djhonz7dexnot.cloudfront.net/83ed82625863b02edc29f268456c295ee61c13fc.png" : 
                                            "https://djhonz7dexnot.cloudfront.net/6c60e2bddc3129db6273007c173625af65d2490a.png"} 
                                        width="44px" 
                                        height="44px" 
                                    />
                                </Box>
                                <Box variant="flex"  width="calc(100% - 60px)" ml={8} alignItems="center">
                                    <Box width="calc(100% - 60px)" onClick={() => handlePlayPause(index)}>
                                        <VoiceNameText>{voice.labels.description || voice.name}</VoiceNameText>
                                        {!isSelected ? <GenreAgeText selected={isSelected} >
                                            {getSubText(voice)}
                                        </GenreAgeText> : 
                                        <SelectedGenreAgeText selected={isSelected} >
                                            <TransformationTxt isScrolling>{getSubText(voice)}</TransformationTxt>
                                        </SelectedGenreAgeText>}
                                    </Box>
                                    <Box>
                                        <audio 
                                            ref={(ref) => (audioRefs.current[index] = ref)}
                                            onTimeUpdate={handleAudioTimeUpdate}
                                        >
                                            <source src={voice.sample} type="audio/mp3" />
                                        </audio>
                                    {(audioRefs.current[index]?.paused || !audioRefs.current[index]) ? 
                                        <PlayPauseBtn onClick={() => handlePlayPause(index)}>
                                            <PlayWithCircle />
                                        </PlayPauseBtn>
                                        : 
                                        <PlayPauseBtn onClick={() => handlePlayPause(index)}>
                                            <CircularProgressBar 
                                                angle={angle}
                                                audio={audioRefs.current[index]}/>
                                        </PlayPauseBtn>}
                                    </Box>
                                </Box>
                            </VoiceItem>
                        </li>
                    )})}
                </ul>
            }
        </ListDiv>
    )
}

export default VoiceList